// extracted by mini-css-extract-plugin
export var editButton = "_jb-0";